
const numberWithSpaces = (x) => {
	try {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	} catch (error) {
		return "- "
	}
}

const uppercase = (str) => {
	return str ? str.toUpperCase() : ''
}

const capitalize = (str) => {
	if (!str) {
		return ''
	}
	return str.charAt(0).toUpperCase() + str.slice(1)
}


export {
	numberWithSpaces,
	uppercase,
	capitalize
}